import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { CustomModal } from "components/CustomModal";
import { SuccessCheckmark } from "components/IconsTextsUtils";
import { LinearProgressWithLabel } from "components/LinearProgressWithLabel";
import { Message } from "components/Message";
import { useTranslation } from "react-i18next";
import { percent } from "utils/textSymbols";

import type { ResultDownloadProgress } from "../model/resultDownload";

type TransientJobDownloadModalProps = {
  error: null | string;
  isRunning: boolean;
  onClose: () => void;
  open: boolean;
  progress: ResultDownloadProgress;
};

const statusKey = (phase: ResultDownloadProgress["phase"]) => {
  if (phase === "done") return "Execution.transient.jobDetails.downloadModal.done";
  if (phase === "zip") return "Execution.transient.jobDetails.downloadModal.zipLabel";
  return "Execution.transient.jobDetails.downloadModal.title";
};

export const TransientJobDownloadModal = ({
  error,
  isRunning,
  onClose,
  open,
  progress,
}: TransientJobDownloadModalProps) => {
  const { t } = useTranslation();
  const isDone = progress.phase === "done";

  return (
    <CustomModal closeIcon={false} height="auto" padding="2.4rem" modalOpen={open} setModalOpen={() => {}} width="36rem">
      <Stack className="w-full flex-col items-stretch gap-4">
        <Stack className="w-full justify-between gap-3">
          <h2 className="self-start font-ds-headline-sm">{t(statusKey(progress.phase))}</h2>
          {isDone ? <SuccessCheckmark className="h-5 w-5" /> : null}
        </Stack>
        <LinearProgressWithLabel fullWidth value={progress.percentage} />
        <Stack className="w-full justify-between">
          <span className="font-ds-number-semibold-md">
            {progress.percentage}
            {percent}
          </span>
          <span className="font-ds-number-regular-md text-lds-foreground-muted">
            {t("Execution.transient.jobDetails.downloadModal.progress", {
              done: progress.completed,
              total: progress.total,
            })}
          </span>
        </Stack>
        {error ? <Message message={error} variant="error" /> : null}
        <Button className="self-end" onClick={onClose} size="sm" variant="secondary">
          {t(
            isRunning
              ? "Execution.transient.jobDetails.downloadModal.action.cancel"
              : "Execution.transient.jobDetails.downloadModal.action.close"
          )}
        </Button>
      </Stack>
    </CustomModal>
  );
};
